import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './styles/app.css'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { isLocalhost } from './utils/posthogFilter'

const queryClient = new QueryClient()

// Only initialize PostHog if not on localhost and both env vars are present
const hostname = window.location.hostname
const shouldInitPostHog =
  !isLocalhost(hostname) &&
  import.meta.env.VITE_PUBLIC_POSTHOG_KEY &&
  import.meta.env.VITE_PUBLIC_POSTHOG_HOST

if (shouldInitPostHog) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: '2025-05-24',
    // Delay automatic pageview capture until after we can check for internal users
    capture_pageview: false,
    capture_pageleave: false
  })
}

// Conditionally render PostHogProvider only when PostHog should be initialized
// This prevents PostHog from making any network requests on localhost
const AppWithProviders = shouldInitPostHog ? (
  <PostHogProvider client={posthog}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </PostHogProvider>
) : (
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
)

createRoot(document.getElementById('root')!).render(<StrictMode>{AppWithProviders}</StrictMode>)
